import * as api from './api'
import { ONE_HOUR } from '@/constants/time'
import { checkTtlDate } from '@/helper'
import { getLocalData, setLocalData } from '@/helper/localStorage'
import { WORKING_SHIFT } from '@/constants/localStorage'

export default {
  async loadData ({ commit }, { force = false } = {}) {
    const workingShiftLocal = getLocalData(WORKING_SHIFT)
    const isNeedUpdate = checkTtlDate({
      timeUpdate: (workingShiftLocal?.updateDate || 0),
      ttlTime: ONE_HOUR
    })

    if (!force && workingShiftLocal && !isNeedUpdate) {
      commit('setData', workingShiftLocal.data)

      return { data: workingShiftLocal.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      commit('setData', data.data)

      setLocalData(WORKING_SHIFT, {
        updateDate: Date.now(),
        data: data.data
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async loadDataByUserId (_, { userId, dateRange }) {
    const { data } = await api.loadDataByUserId(userId, dateRange) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data.data }
  },
  async open ({ commit, state }, { amount }) {
    const { data } = await api.open(amount) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.unshift(data.data)

      commit('setData', newData)

      setLocalData(WORKING_SHIFT, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async close ({ commit, state }, { amount }) {
    const { data } = await api.close(amount) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === data.data.id) {
          item = {
            ...item,
            ...data.data
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(WORKING_SHIFT, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, { id, data: payloadData } = {}) {
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = data.data
        }

        return item
      })

      commit('setData', newData)

      setLocalData(WORKING_SHIFT, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, payload) {
    const { data } = await api.remove(payload) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({ id }) => id !== payload )

      commit('setData', newData)

      setLocalData(WORKING_SHIFT, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  }
}